module.exports = __webpack_public_path__ + "img/方块初级大师@3x.c07057ea.png";